import { Button, Col, Modal, Row } from 'reactstrap';
import { useEffect, useState } from 'react';
import { fillForm } from '../../../../services/PreEmploymentPDFService';

type PreEmploymentFormModalProps = {
  isOpen: boolean;
  data: any;
  uploadedPdf?: string;
  toggleModal: (e?: any) => void;
};

const PreEmploymentFormModal = ({ isOpen, data, uploadedPdf, toggleModal }: PreEmploymentFormModalProps) => {
  const [pdf, setPdf] = useState('');

  useEffect(() => {
    if (isOpen) {
      loadPdf();
    }
  }, [isOpen]);

  const loadPdf = async () => {
    try {
      if (!uploadedPdf) {
        const pdfBytes = await fillForm(data.fileUrl, data.formData, data.employmentHistory);
        const blob = new Blob([pdfBytes], { type: 'application/pdf' });
        const docUrl = URL.createObjectURL(blob);
        return setPdf(docUrl);
      }
      setPdf(uploadedPdf);
    } catch (e) {
      console.log(e);
    }
  };

  const handleDownloadPdf = () => {
    if (!pdf) {
      return;
    }
    const link = document.createElement('a');
    link.href = pdf;
    const filename = `application.pdf`;
    link.setAttribute('download', filename);
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Modal className="modal-dialog-centered" size="xl" isOpen={isOpen} toggle={(e: any) => toggleModal(e)}>
        <div className="modal-header pb-1">
          <h5 className="modal-title">{data?.options?.title || ''}</h5>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={(e) => toggleModal(e)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body pt-0">
          <Row className="mt-2">
            <Col md="12" lg="12">
              <div className="d-flex justify-content-end">
                <Button color="primary" onClick={handleDownloadPdf} size="sm">
                  Download (PDF)
                </Button>
              </div>
            </Col>
            <Col md="12" lg="12" className="mt-4" style={{ maxHeight: '500px', overflow: 'scroll' }}>
              <iframe src={pdf} style={{ minHeight: 500, width: '100%' }} />
            </Col>
          </Row>
        </div>
      </Modal>
    </>
  );
};

export default PreEmploymentFormModal;
